import { render } from "./AyudaDiagAten.vue?vue&type=template&id=72151ead&scoped=true"
import script from "./AyudaDiagAten.vue?vue&type=script&lang=js"
export * from "./AyudaDiagAten.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=72151ead&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72151ead"]])

export default __exports__